import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import type { ButtonHTMLAttributes } from "react";

import { cn } from "../cn";

const buttonVariants = cva(
  "inline-flex min-h-[var(--touch)] items-center justify-center gap-2 rounded-full px-5 text-ui font-semibold transition-colors disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        primary: "bg-ink text-paper hover:bg-ink/90",
        secondary: "border border-line bg-paper text-ink hover:bg-surface",
        ghost: "text-ink hover:bg-surface",
        danger: "bg-[#8c2f2f] text-paper hover:bg-[#8c2f2f]/90",
      },
      size: {
        md: "",
        sm: "min-h-9 px-4 text-[14px]",
        icon: "w-[var(--touch)] px-0",
      },
    },
    defaultVariants: { variant: "primary", size: "md" },
  },
);

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof buttonVariants> & {
    /** Vira `data-track` (Olho de Hórus): obrigatório em tudo que é clicável. */
    track: string;
    /** Renderiza o filho (ex.: um <Link>) com o estilo de botão. */
    asChild?: boolean;
  };

export function Button({
  className,
  variant,
  size,
  track,
  asChild = false,
  type,
  ...props
}: ButtonProps) {
  const Comp = asChild ? Slot : "button";
  return (
    <Comp
      data-track={track}
      className={cn(buttonVariants({ variant, size }), className)}
      {...(asChild ? {} : { type: type ?? "button" })}
      {...props}
    />
  );
}
